import React from "react";
import NoContent from "./NoContent";
import HomePage from "@system/config/home-page";

const NewProductInformation = (props) => {
  const { npiList, searchText, tab } = props;
  return (
    <>
      <div className="search-item-title text-uppercase">
        RECOMMENDED New Product Information
      </div>
      {Object.keys(npiList).length > 0 && (
        <>
          <div className="search-product-list">
            {Object.keys(npiList).length > 0 &&
              Object.entries(npiList).map((v, i) => (
                <React.Fragment key={i}>
                  {i < 5 && (
                    <div className="search-product-list-item">
                      <div className="search-product-list-item-info">
                        <a
                          href={v[1]?.url}
                          className="cursor-pointer"
                          key={i}
                        >
                          <div className="search-product-list-info-title">
                            {v[1].name}
                          </div>

                        </a>
                        <div className="search-product-list-info-desc">
                          {v[1].shortDescription}
                        </div>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
          </div>
          <a
            href={
              HomePage.makeHomeTabsListRouteURL(tab) +"&search=" +searchText}
            className="text-center mt-auto pb-3 pt-3"
          >
            <div className="bs5 btn btn-sm btn-primary">
              VIEW ALL New Product Information Results
            </div>
          </a>
        </>
      )}
      {Object.keys(npiList).length === 0 && (
        <>
          <NoContent />
        </>
      )}
    </>
  );
};

export default NewProductInformation;
